


/**
* Intro Phases for External Observer
*/
export enum ObserverPhase{
    /**
    * Welcome
    */
    Welcome = 0,
    /**
    * CookieDisclosure
    */
    CookieDisclosure = 1,
    /**
    * Privacy
    */
    Privacy = 2,
    /**
    * WhatToExpect
    */
    WhatToExpect = 3,
    /**
    * Photo
    */
    Photo = 4,
    /**
    * Queue
    */
    Queue = 5,
    /**
    * GuideStreamOnline
    */
    GuideStreamOnline = 6,
    /**
    * SessionEndedTemporarily
    */
    SessionEndedTemporarily = 7,
    /**
    * SessionEnded
    */
    SessionEnded = 8,
    /**
    * Unable to access because of device permissions
    */
    AccessDenied = 9,
    /**
    * Denied Access to Session by Mentor
    */
    Denied = 10,
    /**
    * Removed from session by Mentor
    */
    Removed = 11,
    /**
    * The max number of external observers are already in the session
    */
    ObserversAtCapacity = 12
}

